import type { EntryPointRouteParams } from '@atlassian/jira-entry-points-plugin/src/common/types.tsx';
import { createAri } from '@atlassian/jira-platform-ari/src/index.tsx';
import parameters from '@atlassian/jira-relay/src/__generated__/ui_jiraCapacityQuery$parameters';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const capacityEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() => import(/* webpackChunkName: "async-jira-capacity" */ './src'),
	),
	getPreloadProps: (entryPointRouteParams: EntryPointRouteParams) => {
		const {
			context: { match },
			tenantContext,
		} = entryPointRouteParams;

		const sourceAri = createAri({
			resourceOwner: 'jira-software',
			cloudId: tenantContext.cloudId,
			resourceType: 'board',
			resourceId: match.params.boardId ?? '',
		});

		return {
			queries: {
				capacityData: {
					options: {
						fetchPolicy: 'store-and-network' as const,
					},
					parameters,
					variables: {
						cloudId: tenantContext.cloudId,
						id: sourceAri,
					},
				},
			},
			entryPoints: {},
			extraProps: {
				tenantContext,
			},
		};
	},
});
